<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rhbgHN/tc-custom/9780253023193.jpg?1718106016611" alt="This image is the cover for the book Sephardi, Jewish, Argentine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sephardi, Jewish, Argentine
      </h1>
      <p class="bookDescription body article font2">
        <b>“A much-needed monograph on the role of Sephardic Jews in Argentina, and . . . an important contribution to the study of Jews in Latin America overall” (<i>Choice</i>).</b><br/><br/>At the turn of the twentieth century, Jews from North Africa and the Middle East were called Turcos (“Turks”). Seen as distinct from Ashkenazim, Sephardi Jews weren’t even identified as Jews. Yet the story of Sephardi Jewish identity has been deeply impactful on Jewish history across the world. Adriana M. Brodsky follows the history of Sephardim as they arrived in Argentina, created immigrant organizations, founded synagogues and cemeteries, and built strong ties with coreligionists around the country.<br/><br/>Brodsky demonstrates how fragmentation based on areas of origin gave way to the gradual construction of a single Sephardi identity. This unifying identity is predicated both on Zionist identification (with the State of Israel) and “national” feelings (for Argentina), and that Sephardi Jews assumed leadership roles in national Jewish organizations once they integrated into the much larger Askenazi community.<br/><br/>Rather than assume that Sephardi identity was fixed and unchanging, Brodsky highlights the strategic nature of this identity, constructed both from within the various Sephardi groups and from the outside, and reveals that Jewish identity must be understood as part of the process of becoming Argentine.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adriana M. Brodsky
      </h2>
      
      <p class="authorDescription body article"><P>Adriana M. Brodsky is Associate Professor of History at St. Mary's College of Maryland. She is editor (with Raanan Rein) of The New Jewish Argentina: Facets of Jewish Experiences in the Southern Cone, winner of the Latin American Jewish Studies Association Best Book Award in 2013.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47b34504